(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nft-christmas-nativity"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nft-nativity-banner')) {
    customElements.define('nft-nativity-banner', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video) return;
        this.calm = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.near = false;
        const v = this.video;
        v.muted = true;
        v.defaultMuted = true;
        v.playsInline = true;
        this.observer = new IntersectionObserver((entries) => {
          this.near = entries[0].isIntersecting;
          this.sync();
        }, { rootMargin: '300px 0px' });
        this.observer.observe(this);
        document.addEventListener('visibilitychange', () => this.sync());
      }

      pick() {
        const d = this.video.dataset;
        return (window.devicePixelRatio || 1) >= 1.5 && window.innerWidth >= 750 ? d.srcL : d.srcM;
      }

      sync() {
        const v = this.video;
        if (this.calm.matches || document.hidden || !this.near) { if (!v.paused) v.pause(); return; }
        const src = this.pick();
        if (src && v.getAttribute('src') !== src) v.src = src;
        const p = v.play();
        if (p) p.catch(() => {});
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nft-video-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nft-hero')) {
    customElements.define('nft-hero', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('.nft-hero__video');
        if (!this.video) return;
        this.toggle = this.querySelector('.nft-hero__toggle');
        this.paused = false;
        // Reduced motion or data saving: keep the still image only (the video is never downloaded).
        this.calm = window.matchMedia('(prefers-reduced-motion: reduce)');
        const connection = navigator.connection || {};
        if (this.calm.matches || connection.saveData) return;
        this.mobile = window.matchMedia('(max-width: 749px), (max-width: 1199px) and (orientation: portrait)');
        this.play = this.play.bind(this);
        const video = this.video;
        video.muted = true;
        video.defaultMuted = true;
        video.playsInline = true;
        video.addEventListener('playing', () => {
          this.classList.add('is-playing');
          if (this.toggle) this.toggle.hidden = false;
        });
        video.addEventListener('error', () => this.classList.remove('is-playing'));
        if (this.toggle) this.toggle.addEventListener('click', () => this.setPaused(!this.paused));
        const content = this.querySelector('.nft-hero__content');
        if (this.toggle && content && window.ResizeObserver) {
          new ResizeObserver(() => this.style.setProperty('--nft-hero-content-h', content.offsetHeight + 'px')).observe(content);
        }
        this.calm.addEventListener('change', () => { if (this.calm.matches) this.setPaused(true); });
        this.load();
        this.mobile.addEventListener('change', () => { this.classList.remove('is-playing'); this.load(); });
        document.addEventListener('visibilitychange', () => { if (!document.hidden) this.play(); });
      }

      setPaused(paused) {
        this.paused = paused;
        if (paused) this.video.pause(); else this.play();
        if (!this.toggle) return;
        this.toggle.setAttribute('data-paused', paused ? 'true' : 'false');
        const label = paused ? this.toggle.dataset.labelPlay : this.toggle.dataset.labelPause;
        const text = this.toggle.querySelector('[data-nft-hero-label]');
        if (text) text.textContent = label;
      }

      load() {
        const video = this.video;
        const source = this.mobile.matches ? video.dataset.mobileSrc : video.dataset.desktopSrc;
        if (!source) return;
        if (video.getAttribute('src') !== source) {
          video.preload = 'auto';
          video.src = source;
        }
        this.play();
      }

      play() {
        if (this.paused) return;
        const playing = this.video.play();
        if (playing) playing.catch(() => {});
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nft-video-link"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nft-video-link')) {
    customElements.define('nft-video-link', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video) return;
        this.small = window.matchMedia('(max-width: 749px)');
        this.calm = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.near = false;
        const v = this.video;
        v.muted = true;
        v.defaultMuted = true;
        v.playsInline = true;
        this.observer = new IntersectionObserver((entries) => {
          this.near = entries[0].isIntersecting;
          this.sync();
        }, { rootMargin: '300px 0px' });
        this.observer.observe(this);
        this.small.addEventListener('change', () => { v.removeAttribute('src'); v.load(); this.sync(); });
        document.addEventListener('visibilitychange', () => this.sync());
      }

      pick() {
        const d = this.video.dataset;
        if (this.small.matches) return d.srcS;
        return (window.devicePixelRatio || 1) >= 1.5 ? d.srcL : d.srcM;
      }

      sync() {
        const v = this.video;
        if (this.calm.matches || document.hidden || !this.near) { if (!v.paused) v.pause(); return; }
        const src = this.pick();
        if (src && v.getAttribute('src') !== src) v.src = src;
        const p = v.play();
        if (p) p.catch(() => {});
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
